import { RARITY_POINTS } from 'src/models/Item'

export const GetItemName = (type) => {
  switch (type) {
    case 'heart':
      return 'ハート'
    case 'blue_diamond':
      return '青ダイア'
    default:
      return 'アイテム'
  }
}

export const getRarityPoints = (rarity) => RARITY_POINTS[rarity] ?? 0

export const calcPoint = (remainPoint = 0, selectedExchange = {}) => {
  for (const { amount, rarity } of Object.values(selectedExchange)) {
    remainPoint += getRarityPoints(rarity) * amount
  }
  return remainPoint
}

export const buildExchangeParam = (selectedExchange = {}) =>
  Object.entries(selectedExchange).map(([itemId, { amount }]) => ({
    id: Number(itemId),
    amount
  }))

export const getUnusableAmount = (item) =>
  item.has_attached_icon && item.attached_amount === 0 ? 1 : item.attached_amount
